<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Colloques" />
            <LesColloques />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesColloques from './LesColloques.vue';


export default {
    name: 'ColloquesPage',
    components: {
        NavBar,
        PageTitle,
        LesColloques,
        FooterComp,
    }
}
</script>